import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import AboutKrystal from "./components/AboutKrystal";
import WhoItsFor from "./components/WhoItsFor";
import WhatYoullGain from "./components/WhatYoullGain";
import Experience from "./components/Experience";
import Testimonial from "./components/Testimonial";
import CallToAction from "./components/CallToAction";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="font-sans bg-white scroll-smooth">
      <Navbar />
      <main>
        <Hero />
        <WhoItsFor />
        <WhatYoullGain />
        <Experience />
        <AboutKrystal />
        <Testimonial />
        <CallToAction />
      </main>
      <Footer />
    </div>
  );
}
